// extracted by mini-css-extract-plugin
export default {"imageWrapper":"AJ-z","twoColumnImage":"BJ-z"};